module.exports = __webpack_public_path__ + "static/media/story_zoom.fa9b13e1.png";